import styled from "styled-components";

type ProgressBarProps = {
    loading: boolean
}

export const ProgressBarContainer = styled.div<ProgressBarProps>`
  
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0, 0.3);
  z-index: 5000;
  display: ${({loading}) => loading ? 'flex': "none"};
`

export const ProgressBarBody = styled.div`
  width: 30%;
  height: 10%;
  //background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ProgressBarText= styled.p`
 margin: 0;
  padding: 0;
`
